// @flow

import React, { Component } from 'react'
import moment from 'moment'
// $FlowFixMe
import chrono from 'chrono-node'

// $FlowFixMe
import Select from 'react-select'
// $FlowFixMe
import { Div, Span } from 'react-select/lib/primitives'
// $FlowFixMe
import { components as SelectComponents } from 'react-select'

import { ArrowLeft, ArrowRight } from 'src/components/Icons'

const createOptionForDate = (d: any) => {
  const date = moment.isMoment(d) ? d : moment(d)
  return {
    date,
    value: date.toDate(),
    label: date.calendar(null, {
      sameDay: '[Today] (Do MMM YYYY)',
      nextDay: '[Tomorrow] (Do MMM YYYY)',
      nextWeek: '[Next] dddd (Do MMM YYYY)',
      lastDay: '[Yesterday] (Do MMM YYYY)',
      lastWeek: '[Last] dddd (Do MMM YYYY)',
      sameElse: 'Do MMMM YYYY'
    })
  }
}

const defaultOptions = []

const suggestions = [
  'sunday',
  'saturday',
  'friday',
  'thursday',
  'wednesday',
  'tuesday',
  'monday',
  'december',
  'november',
  'october',
  'september',
  'august',
  'july',
  'june',
  'may',
  'april',
  'march',
  'february',
  'january',
  'yesterday',
  'tomorrow',
  'today'
].reduce((acc, str) => {
  for (let i = 1; i < str.length; i++) {
    acc[str.substr(0, i)] = str
  }
  return acc
}, {})

const suggest = (str: string) =>
  str
    .split(/\b/)
    .map(i => suggestions[i] || i)
    .join('')

const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const daysHeaderStyles = {
  marginTop: '5px',
  paddingTop: '5px',
  paddingLeft: '2%'
}
const headingStyles = {
  display: 'flex',
  justifyContent: 'space-between'
}
const titleStyles = {
  fontFamily: "'RelativeBook', 'Helvetica', 'Arial', sans-serif",
  fontSize: '16px'
}
const daysHeaderItemStyles = {
  color: '#4a5665',
  cursor: 'default',
  display: 'inline-block',
  width: '12%',
  margin: '0 1%',
  textAlign: 'center',
  fontFamily: 'RelativeBook',
  fontSize: '14px'
}
const daysContainerStyles = {
  paddingTop: '5px',
  paddingLeft: '2%'
}

type GroupProps = {
  Heading: Object,
  getStyles: Function,
  children: any,
  label: string,
  innerProps: Object,
  selectProps: { previousMonth: string, nextMonth: string },
  headingProps: Object,
  cx: string
}

const Group = (props: GroupProps) => {
  const {
    Heading,
    getStyles,
    children,
    label,
    innerProps,
    selectProps: { previousMonth, nextMonth },
    headingProps,
    cx
  } = props
  return (
    <Div aria-label={label} css={getStyles('group', props)} {...innerProps}>
      <Heading getStyles={getStyles} cx={cx} {...headingProps}>
        <Div css={headingStyles}>
          <button onClick={previousMonth} type="button">
            <ArrowLeft />
          </button>
          <Div css={titleStyles}>{label}</Div>
          <button onClick={nextMonth} type="button">
            <ArrowRight />
          </button>
        </Div>
      </Heading>
      <Div css={daysHeaderStyles}>
        {days.map((day, i) => (
          <Span key={`${i}-${day}`} css={daysHeaderItemStyles}>
            {day}
          </Span>
        ))}
      </Div>
      <Div css={daysContainerStyles}>{children}</Div>
    </Div>
  )
}

const getOptionStyles = (
  defaultStyles: Object,
  isDisabled: boolean,
  isSelected: boolean,
  isFocused: boolean
) => ({
  ...defaultStyles,
  display: 'inline-block',
  width: '12%',
  margin: '1px 1%',
  textAlign: 'center',
  borderRadius: '4px',
  border: `${isSelected ? 'solid 1px #29dc8d' : 'solid 1px #d2d9e2'}`,
  backgroundColor: `${isSelected ? 'transparent' : isFocused ? 'transparent' : 'transparent'}`,
  backgroundImage: `${
    isDisabled
      ? 'linear-gradient(#f8f8f8, #f8f8f8)'
      : isSelected
      ? 'linear-gradient(#29dc8d, #29dc8d)'
      : 'none'
  }`,
  ':active': {
    backgroundColor: isSelected ? 'transparent' : 'transparent'
  },
  ':hover': {
    border: `${isDisabled ? 'solid 1px #d2d9e2' : 'solid 1px rgba(47, 231, 150, 0.8)'}`,
    backgroundImage: `${
      isDisabled ? '' : 'linear-gradient(rgba(47, 231, 150, 0.8), rgba(47, 231, 150, 0.8))'
    }`
  }
})

const Option = (props: Object) => {
  const { data, getStyles, innerRef, innerProps, isSelected, isDisabled, isFocused } = props
  if (data.display === 'calendar') {
    const defaultStyles = getStyles('option', props)
    const styles = getOptionStyles(defaultStyles, isDisabled, isSelected, isFocused)
    if (data.date.date() === 1) {
      const indentBy = data.date.day()
      if (indentBy) {
        styles.marginLeft = `${indentBy * 14 + 1}%`
      }
    }
    return (
      <Span {...innerProps} css={styles} ref={innerRef}>
        {data.date.format('D')}
      </Span>
    )
  } else return <SelectComponents.Option {...props} />
}

export type OptionType = {
  date?: moment,
  label: string,
  value?: Date
}

type Props = {
  handleInputChange: Function,
  onChange: Function,
  value: string
}

type State = {
  options: Array<OptionType>
}

class DobDatePicker extends Component<Props, State> {
  state = {
    options: defaultOptions
  }

  handleInputChange = (value: string) => {
    if (!value) {
      this.setState({ options: defaultOptions })
      return
    }
    const date = chrono.en_GB.parseDate(suggest(value.toLowerCase()))
    if (date) {
      this.setState({
        options: [createOptionForDate(date)]
      })
    } else {
      this.setState({
        options: []
      })
    }
  }

  render() {
    const { value } = this.props
    const { options } = this.state
    return (
      <Select
        {...this.props}
        components={{ Group, Option }}
        filterOption={null}
        isMulti={false}
        isOptionSelected={(o, v) =>
          v.some(i => {
            i.date = moment.isMoment(i.date) ? i.date : moment(i.date)
            return i.date.isSame(o.date, 'day')
          })
        }
        maxMenuHeight={380}
        onChange={this.props.onChange}
        onInputChange={this.handleInputChange}
        options={options}
        value={value}
        placeholder="DD/MM/YYYY"
      />
    )
  }
}

export default DobDatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker/DobDatePicker.js